module.exports = __webpack_public_path__ + "img/CS-Lite-Plus_Overview-Rear_2.dec79796.jpg";